import * as Sentry from '@sentry/react';

// Este archivo se importa como el PRIMER import de main.jsx, antes que App.
// Así, si algo revienta durante la evaluación del módulo (p. ej. el bug de
// userInfo.js que arrancaba con un JSON.parse sin protección), Sentry ya
// tiene sus manejadores globales (window.onerror/unhandledrejection)
// instalados y lo captura, en vez de perderse en una pantalla en blanco
// silenciosa sin ningún rastro.
const dsn = process.env.REACT_APP_SENTRY_DSN;

if (dsn) {
  Sentry.init({
    dsn,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || 'unknown',
    integrations: [
      // Enmascara TODO el texto e inputs por defecto (maskAllText/blockAllMedia
      // quedan en true si no se tocan) — no se ve nada de lo que el usuario
      // escribe, incluyendo email/password en /login.
      Sentry.replayIntegration()
    ],
    // 0 = nunca graba sesiones normales/exitosas. Solo se graba (y consume
    // cuota) cuando una sesión efectivamente tira un error no manejado —
    // exactamente el caso que queremos poder reproducir. El plan Developer
    // (gratuito) de Sentry incluye 50 replays/mes; con este muestreo el
    // consumo queda atado al volumen de errores reales, no al de visitas.
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0
  });
}

export { Sentry };
